import { useEffect, useState } from 'react';
import type { Config, Row } from '../types/hooks';
import { reportService } from '../services/service';
import { PermisosReportes, usePermisoReportes } from '../../../../auth/permisosModulos';

const useToolbar = () => {
    const canViewResults = usePermisoReportes('listado-resultados');
    const canViewReports = usePermisoReportes('listar-reportes');
    const canCreateReport = usePermisoReportes('crear-reporte');
    const canDeleteResult = usePermisoReportes('eliminar-resultado');
    const [reportsResult, setReportsResult] = useState<Row[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const search = async () => {
        if (!canViewResults) return;

        let configs: Config[] = JSON.parse(localStorage.getItem('config_system') || '[]');

        const { results } = await reportService.getResults({
            columns_select: ['*'],
            where_select: {
                company_id: parseInt(configs.find((config) => config.key === 'company_id')?.value || '0'),
            },
        });

        const { reports } = canViewReports
            ? await reportService.getReports({
                  columns_select: ['*'],
                  where_select: {
                      id: `$FIND_IN_SET$${[...new Set(results.map((result) => result.report_id))].join(',')}`,
                  },
              })
            : { reports: [] };

        setReportsResult(
            results.map((result) => {
                const report = reports.find((r) => r.id === result.report_id);

                return {
                    id: result.id,
                    report_name: report?.name || result.report_id.toString(),
                    created_at: result.created_at,
                    finished_at: result.updated_at,
                    state: result.status,
                    format: {
                        htmlUrl: `${configs.find((config) => config.key === 'report_domain')?.value}/reports/download?reportResultId=${result.id}&format=html`,
                        pdfUrl: `${configs.find((config) => config.key === 'report_domain')?.value}/reports/download?reportResultId=${result.id}&format=pdf`,
                        xlsUrl: `${configs.find((config) => config.key === 'report_domain')?.value}/reports/download?reportResultId=${result.id}&format=xls`,
                        docUrl: `${configs.find((config) => config.key === 'report_domain')?.value}/reports/download?reportResultId=${result.id}&format=doc`,
                    },
                } as Row;
            }),
        );
    };

    useEffect(() => {
        if (canViewResults) search();
    }, [canViewResults, canViewReports]);

    return {
        loading,
        setLoading,
        search,
        reportsResult,
        canViewTable: canViewResults,
        canCreateReport,
        canDeleteResult,
        requiredPermissions: PermisosReportes['listado-resultados'],
    };
};

export { useToolbar };
